function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styled from 'styled-components';
import { headline5 } from '../../../tokens';
export { Headline1, Headline2, Headline3, Headline4 } from '@salutejs/plasma-core';
export var Headline5 = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma-web-core__sc-gxtjrl-0"
})( /*#__PURE__*/_objectSpread({
  overflowWrap: 'break-word',
  hyphens: 'auto'
}, headline5));
export var H5 = /*#__PURE__*/styled.h5.withConfig({
  componentId: "plasma-web-core__sc-gxtjrl-1"
})( /*#__PURE__*/_objectSpread({
  margin: 0
}, headline5));